import { render, staticRenderFns } from "./extraWeekly.vue?vue&type=template&id=45cb29f4&scoped=true&"
import script from "./extraWeekly.vue?vue&type=script&lang=js&"
export * from "./extraWeekly.vue?vue&type=script&lang=js&"
import style0 from "./extraWeekly.vue?vue&type=style&index=0&id=45cb29f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb29f4",
  null
  
)

export default component.exports